<template>
  <div class="pageWrapper">
    <div class="container">
      <div class="middle-text">
        <h1>404</h1>
        <p>Page not found</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    data () {
        return {};
    },
};
</script>

<style lang="scss" scoped>
.middle-text {
  text-align: center;
  margin-top: 100px;
  h1 {
    font-size: 80px;
  }
}
</style>
